import { CRUD } from "@/shared/components";
import { ProductPurchasesListQuery } from "@/admin/entities/productPurchases";
import {
  useProductPurchasesManagement,
  type ProductPurchaseRow,
  ProductPurchasesSchemas,
} from "../model";

/**
 * Реестр покупок (разовых и подписок). Создания и удаления нет; из действий
 * в строке: остановка покупки, правка сроков и переключение автопродления.
 */
export function ProductPurchases() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useProductPurchasesManagement();

  return (
    <CRUD<ProductPurchaseRow>
      listQuery={ProductPurchasesListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={ProductPurchasesSchemas.filterSchema}
      normalizeFilter={ProductPurchasesSchemas.normalizeProductPurchasesFilter}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
